<template>
  <div class="face-container" id="page-face">
    <img class="face-title" src="https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/fb-title.png" alt="" />
    <div class="face-content">
      <div class="house">
        <div class="house__role" />
        <div class="fb-window">
          <div
            class="fb-page"
            data-href="https://www.facebook.com/profile.php?id=100083216304166"
            data-tabs="timeline"
            data-width="500"
            data-height="470"
            data-small-header="false"
            data-adapt-container-width="true"
            data-hide-cover="false"
            data-show-facepile="true"
          >
            <blockquote
              cite="https://www.facebook.com/profile.php?id=100083216304166"
              class="fb-xfbml-parse-ignore"
            >
              <a href="https://www.facebook.com/profile.php?id=100083216304166"
                >歡樂大東家-回到古代 做點買賣</a
              >
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.initFaceBook();
    this.$nextTick(() => {
      new this.$Swiper('.face-swiper-container', {
        loop: true,
        speed: 500,
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true, // 允许点击小圆点跳转
        },
        //如果需要自动切换海报
        autoplay: {
          delay: 1000,
          disableOnInteraction: false, // 手动切换之后继续自动轮播
        },
      });
    });
  },

  methods: {
    initFaceBook() {
      window.faceBooke = (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.nonce = 'AlZYDPf5';
        js.src =
          'https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v14.0&appId= 309746810979871&autoLogAppEvents=1';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    },
  },
};
</script>
<style scoped lang="scss" src="./scss/face.scss">
</style>